import React from "react";
import Bar from '../JSX/Bar';
import Footer from '../JSX/Footer';


const Service = () => {
  return (
        <div>
        <Bar/>
    {/* ======= Services Section ======= */}
    <section id="services" className="services">
      <div className="container" data-aos="fade-up">
        <div className="section-header">
          <h2>Our Services</h2>
          <p>
            Ea vitae aspernatur deserunt voluptatem impedit deserunt magnam
            occaecati dssumenda quas ut ad dolores adipisci aliquam.
          </p>
        </div>
        <div className="row gy-5">
          <div
            className="col-xl-4 col-md-6"
            data-aos="zoom-in"
            data-aos-delay={200}
          >
            <div className="service-item">
              <div className="img">
                <img
                  src="./img/services-1.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
              <div className="details position-relative">
                <div className="icon">
                  <i className="bi bi-activity" />
                </div>
                <a href="/Form" className="stretched-link">
                  <h3>Feasibility Study</h3>
                </a>
                <p>
                  Provident nihil minus qui consequatur non omnis maiores.
                </p>
              </div>
            </div>
          </div>
          {/* End Service Item */}
          <div
            className="col-xl-4 col-md-6"
            data-aos="zoom-in"
            data-aos-delay={300}
          >
            <div className="service-item">
              <div className="img">
                <img
                  src="./img/services-2.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
              <div className="details position-relative">
                <div className="icon">
                  <i className="bi bi-easel" />
                </div>
                <a href="/Models" className="stretched-link">
                  <h3>Investment Models</h3>
                </a>
                <p>
                  Ut autem aut autem non a. Sint sint sit facilis nam iusto
                </p>
              </div>
            </div>
          </div>
          {/* End Service Item */}
          <div
            className="col-xl-4 col-md-6"
            data-aos="zoom-in"
            data-aos-delay={400}
          >
            <div className="service-item">
              <div className="img">
                <img
                  src="./img/services-5.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
              <div className="details position-relative">
                <div className="icon">
                  <i className="bi bi-calendar4-week" />
                </div>
                <a href="/Price" className="stretched-link">
                  <h3>Pricing Feasibility Study</h3>
                </a>
                <p>
                  Cumque et suscipit saepe. Est maiores autem enim facilis ut
                </p>
                {<a href="/Price" className="stretched-link" />}
              </div>
            </div>
          </div>
          {/* End Service Item */}
        </div>
          {/* End Service Item */}

      </div>
      <div className="container" >
        <div className="row">
          
      <div
            className="col-sm-5 mx-auto"
            data-aos="zoom-in"
            data-aos-delay={500}
          >
            <div className="service-item">
              <div className="img">
                <img
                  src="./img/services-6.jpg"
                  className="img-fluid"
                  alt=""
                />
              </div>
              <div className="details position-relative">
                <div className="icon">
                  <i className="bi bi-chat-square-text" />
                </div>
                <a href="/Consulting" className="stretched-link">
                  <h3>Consulting Services</h3>
                </a>
                <p>
                  Hic molestias ea quibusdam eos. Fugiat enim doloremque aut
                </p>
              </div>
              </div>
              </div>
            </div>
          </div>

    </section>
    {/* End Services Section */}
        <Footer/>
        </div>
  );
};

export default Service;